import { Files, getApiUrl, rawPost } from "@app/shared";
import cn from "classnames";
import React, { ChangeEventHandler, useEffect, useRef, useState } from 'react';
import { IconLink, Icons, MediaSelectorItem } from '.';
import { useConfirmDialog, useFetch } from '../../hooks';

type MediaSelectorProps = {
    value: string | undefined;
    allowMultiple?: boolean;
    onChange?: (newVal: string) => void;
    fileDescription?: string;
    fileTypes?: string;
    organizationId?: string;
    path?: string;
    onFilesChanged?: (files?: string[]) => void;
    listFormat?: boolean;
};

export const MediaSelector: React.FC<MediaSelectorProps> = ({ onFilesChanged, ...props }) => {
    const [files, , filesHelper] = useFetch(() => Files.list(props.organizationId, props.path));
    // const [isDragging, setIsDragging] = useState(false);
    const hiddenFileInput = useRef<HTMLInputElement>(null);
    const [filesToUpload, setFilesToUpload] = useState<File[]>()
    const confirm = useConfirmDialog();

    const handleAddImageClick = () => {
        hiddenFileInput.current?.click();
    }
    const handleImageClick = (fileName: string) => {
        props.onChange?.(fileName);
    }
    const handleDeleteClick = (fileName: string) => {
        confirm.show("Delete", `Are you sure you want to delete this ${props.fileDescription ?? "image"} [${fileName}]`, "Delete", async () => {
            await Files.deleteFile(props.organizationId, props.path ? props.path + "/" + fileName : fileName);
            filesHelper.refreshData();
        });
    }
    const handleFileInputChanged: ChangeEventHandler<HTMLInputElement> = (e) => {
        const files: File[] = [];
        //Upload files
        for (var i = 0; i < (e.target.files?.length ?? 0); i++) {
            var file = e.target.files?.item(i);
            if (file)
                files.push(file);
        }
        setFilesToUpload(files);
    }

    useEffect(() => {
        if (!filesToUpload || filesToUpload.length === 0)
            return;

        //Upload the first file, then clear it off the filesToUpload so this will run again for the next
        try {
            var formData = new FormData();
            formData.append('File', filesToUpload[0]);
            rawPost(`/api/file/${props.organizationId ?? "public"}` + (props.path ? "?path=" + props.path : ""), formData).then(() => {
                setFilesToUpload(filesToUpload?.slice(1));
                filesHelper.refreshData();
            });


        } catch (e) {
            console.warn("Error uploading file: " + e);
            setFilesToUpload(filesToUpload?.slice(1));
        }
    }, [filesToUpload]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        onFilesChanged?.(files);
    }, [files, onFilesChanged]);
    return (
        <>
            <input ref={hiddenFileInput} type="file" accept={props.fileTypes ?? ".jpg,.gif,.png"} multiple={props.allowMultiple} className="hidden" onChange={handleFileInputChanged} />
            <div className={cn("w-full overflow-auto flex p-3 gap-5  max-h-96", { "flex-col": props.listFormat }, { "flex-wrap": !props.listFormat })}>
                {/* {isDragging &&
                    <div className="w-full h-full bg-background-page bg-opacity-50 absolute text-center flex">
                        <div className="self-center w-full">
                            <SharedIcons.DragDropFill width={175} height={175} />
                            <p className="text-center w-full font-bold text-xl">Drop Files Here</p>
                        </div>
                    </div >
                } */}

                <MediaSelectorItem onClick={handleAddImageClick} listFormat={props.listFormat}>
                    <div className={cn({ "pb-8": !props.listFormat })}>
                        <p className={cn("font-bold text-center", { "text-7xl": !props.listFormat })}>+</p>
                        <p className="text-center">Add New {props.fileDescription ?? "Image"}{props.allowMultiple ? "(s)" : ""}</p>
                    </div>
                </MediaSelectorItem>

                {filesToUpload && filesToUpload.length > 0 &&
                    filesToUpload.map(f => (
                        <MediaSelectorItem title={<div>{f.name}</div>} listFormat={props.listFormat}>
                            <div>Uploading...</div>
                        </MediaSelectorItem>
                    ))
                }

                {files && files.length > 0 &&
                    files.map(f => (
                        <React.Fragment key={f}>
                            <MediaSelectorItem listFormat={props.listFormat} selected={props.value === f} imageUrl={getApiUrl("/api/File/Download?path=" + f)} onClick={() => handleImageClick(f)} title={
                                <div className="flex">
                                    <div className="flex-grow">
                                        {decodeURIComponent(f.replace(/\\+/g, "%20"))}
                                    </div>
                                    <IconLink Icon={Icons.Trash} onClick={() => handleDeleteClick(f)}></IconLink>
                                </div>
                            } />
                        </React.Fragment>
                    ))
                }
            </div >
            {confirm.renderDialog()}
        </>
    );
}